// test1230
(1230 && 0);
